import CartApiFactory from "@/services/CartApiFactory.js";

const appKey = "WEB7A5EC9705EB7AC2C984033E06189D"; // UAT:UAT44488833322

export default {
    async getCartSuggestion(cartId, token) {
        let res = await CartApiFactory.get("/carts/" + cartId + "/suggest", {
            headers: {
                token: token
            }
        });
        return res.data;
    },
    async getInfoInput(cartId, token) {
        let res = await CartApiFactory.get("/carts/" + cartId + "/infoInputs", {
            headers: {
                token: token
            }
        });
        return res.data;
    },
    async getAdditionalInfoInput(params) {
        let res = await CartApiFactory.get("/products/" + params + "/infoInputs");
        return res.data;
    },
    async getCartId(param) {
        let res = await CartApiFactory.get("/members/" + param + "/cart", {
            headers: {
                appKey: appKey
            }
        });
        return res.data;
    },
    async addItemToCart(cartId, token, params) {
        let res = await CartApiFactory.post("/carts/" + cartId + "/items", params, {
            headers: {
                token: token
            }
        });
        return res.data;
    },
    async updateCartItem(cartId, token, itemKey, params) {
        let res = await CartApiFactory.patch("/carts/" + cartId + "/items/" + itemKey, params, {
            headers: {
                token: token
            }
        });
        return res.data;
    },
    async getItemCount(param) {
        let res = await CartApiFactory.get("/carts/" + param);
        return res.data;
    },
    async getShoppingCart(cartId, token) {
        let res = await CartApiFactory.get("/carts/" + cartId + "/items", {
            headers: {
                token: token
            }
        });
        return res.data;
    },
    async submitItemKeys(cartId, token, itemKeys) {
        let res = await CartApiFactory.put("/carts/" + cartId + "/proceed", {
            itemKeys: itemKeys,
        },
            {
                headers: {
                    token: token,
                },
            });
        return res.data;
    },
    async deleteItemKey(cartId, token, itemKey) {
        let res = await CartApiFactory.delete("/carts/" + cartId + "/items/" + itemKey, {
            headers: {
                token: token
            }
        });
        return res.data;
    },
    async getPromoCode(cartId, token, promoCode) {
        let res = await CartApiFactory.put("/carts/" + cartId + "/promocode",
            {
                promoCode: promoCode,
            },
            {
                headers: {
                    token: token
                },
            });
        return res.data;
    },
    async submitInfoInput(cartId, token, params) {
        let res = await CartApiFactory.patch("/carts/" + cartId + "/infoInputs", params, {
            headers: {
                token: token
            }
        });
        return res.data;
    },
    async confirmPayment(cartId, token, paymentMethod, optIn) {
        const params = {
            paymentMethod: paymentMethod,
            optIn: optIn
        };
        let res = await CartApiFactory.post("/carts/" + cartId + "/confirm", params,
            {
                headers: {
                    token: token
                },
            });
        return res.data;
    },
    async reConfirmPayment(bookingNo, deleteKeys, confirmToken) {
        let res = await CartApiFactory.post("/bookings/" + bookingNo + "/reconfirm",
            {
                deleteKeys: deleteKeys
            },
            {
                headers: {
                    token: confirmToken
                },
            });
        return res.data;
    },
    async retryPayment(bookingNo, webBookingNo, confirmToken) {
        let res = await CartApiFactory.post("/bookings/" + bookingNo + "/retrypay",
            {
                webBookingNo: webBookingNo + "-R1",
            },
            {
                headers: {
                    token: confirmToken
                },
            });
        return res.data;
    },
    async deleteBooking(bookingNo, confirmToken) {
        let res = await CartApiFactory.delete("/bookings/" + bookingNo,
            {
                headers: {
                    token: confirmToken
                },
            });
        return res.data;
    },
    async bindMemberToCart(memberId, cartId, token) {
        let res = await CartApiFactory.put("/members/" + memberId + "/cart/" + cartId, null, {
            headers: {
                token: token
            }
        });
        return res.data;
    },
}